const brandIcons = document.querySelectorAll('.hero-banner__brand-icon'); // NodeList of 3 elements [0, 1, 2]
let currentSlide = 1;

setInterval(function () {
  if (window.innerWidth < 990) {
    // 1- Clear Active
    brandIcons.forEach(icon => icon.classList.remove('active'));

    // 2- Show Next Icon if it exists
    if (brandIcons[currentSlide]) { // Ensure the icon exists
      brandIcons[currentSlide].classList.add('active');
    } else {
      return;
    }

    // 3- Increment
    if (currentSlide === brandIcons.length - 1) {
      currentSlide = 0;
    } else {
      currentSlide++;
    }
  }
}, 5000);